import React from 'react';
import Notes from '../Sections/Notes';
import Navigator from '../UI/Navigator';

const AdditionalNotes = () => (
  <Navigator>
    <Notes />
  </Navigator>
);

export default AdditionalNotes;
